/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 10.1.2
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface WofContextComponent
 */
export interface WofContextComponent {
  /**
   *
   * @type {string}
   * @memberof WofContextComponent
   */
  abbreviation?: string | null;
  /**
   * A globally unique identifier for a feature. Note: these are not stable for all datasets! For example, OSM features may be deleted and re-added with a new ID. Others like Who's on First guarantee stability long term.
   * @type {string}
   * @memberof WofContextComponent
   */
  gid: string;
  /**
   *
   * @type {string}
   * @memberof WofContextComponent
   */
  name: string;
}

/**
 * Check if a given object implements the WofContextComponent interface.
 */
export function instanceOfWofContextComponent(
  value: object,
): value is WofContextComponent {
  if (!("gid" in value) || value["gid"] === undefined) return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function WofContextComponentFromJSON(json: any): WofContextComponent {
  return WofContextComponentFromJSONTyped(json, false);
}

export function WofContextComponentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): WofContextComponent {
  if (json == null) {
    return json;
  }
  return {
    abbreviation:
      json["abbreviation"] == null ? undefined : json["abbreviation"],
    gid: json["gid"],
    name: json["name"],
  };
}

export function WofContextComponentToJSON(json: any): WofContextComponent {
  return WofContextComponentToJSONTyped(json, false);
}

export function WofContextComponentToJSONTyped(
  value?: WofContextComponent | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    abbreviation: value["abbreviation"],
    gid: value["gid"],
    name: value["name"],
  };
}
